import { render, staticRenderFns } from "./AlternativeButton.vue?vue&type=template&id=2cd6cfd6&scoped=true"
import script from "./AlternativeButton.vue?vue&type=script&lang=js"
export * from "./AlternativeButton.vue?vue&type=script&lang=js"
import style0 from "./AlternativeButton.vue?vue&type=style&index=0&id=2cd6cfd6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd6cfd6",
  null
  
)

export default component.exports